import type { ToursFiltersState } from "../types/filters";

export const DEFAULT_FILTERS: ToursFiltersState = {
  tripsFrom: [],
  tripsTo: [],
  dateFrom: "",
  dateTo: "",
  isDirect: null,
  isRoundTrip: null,
  priceFrom: "",
  priceTo: "",
};
